/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class l{constructor(l=null,a=null,t=null){this.minValue=l,this.maxValue=a,this.noDataValue=t}}export{l as default};
